import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { FileWarning, UserX, FileCheck, Scale, AlertTriangle, Briefcase, ArrowUpRight } from 'lucide-react';
export function Services() {
  const services = [{
    icon: FileWarning,
    title: 'Оскарження рішень ВЛК',
    description: 'Юридичний супровід процедури оскарження висновків військово-лікарської комісії.',
    price: 'від 3000 грн'
  }, {
    icon: UserX,
    title: 'Супровід у ТЦК',
    description: 'Фізичний супровід адвоката при відвідуванні ТЦК. Захист від неправомірних дій.',
    price: 'від 4000 грн'
  }, {
    icon: FileCheck,
    title: 'Оформлення відстрочки',
    description: 'Аналіз підстав, збір документів та подання заяви до ТЦК.',
    price: 'від 2500 грн'
  }, {
    icon: Scale,
    title: 'Судовий захист',
    description: 'Представництво інтересів у судах. Оскарження незаконного призову.',
    price: 'Індивідуально'
  }, {
    icon: AlertTriangle,
    title: 'СЗЧ та Дезертирство',
    description: 'Захист військовослужбовців у кримінальних провадженнях.',
    price: 'Індивідуально'
  }, {
    icon: Briefcase,
    title: 'Звільнення зі служби',
    description: "Допомога у звільненні за станом здоров'я або сімейними обставинами.",
    price: 'від 3500 грн'
  }];
  return <Section id="services" background="white" data-id="element-172">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-12 md:mb-24 gap-4 md:gap-6" data-id="element-173">
        <div className="max-w-2xl" data-id="element-174">
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-black mb-4 md:mb-6" data-id="element-175">
            Послуги
          </h2>
          <p className="text-neutral-500 text-base md:text-lg font-light" data-id="element-176">
            Комплексний юридичний супровід для вирішення ваших питань.
          </p>
        </div>
        <Button variant="outline" className="w-full sm:w-auto" onClick={() => document.getElementById('contact')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-177">
          Всі послуги
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-neutral-200" data-id="element-178">
        {services.map((service, index) => <div key={index} className="group p-6 md:p-8 border-r border-b border-neutral-200 hover:bg-neutral-50 transition-all duration-300 cursor-pointer relative" onClick={() => document.getElementById('contact')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-179">
            <div className="absolute top-6 md:top-8 right-6 md:right-8 opacity-0 group-hover:opacity-100 group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300" data-id="element-180">
              <ArrowUpRight className="h-4 md:h-5 w-4 md:w-5 text-black" data-id="element-181" />
            </div>
            <div className="mb-6 md:mb-8 group-hover:scale-110 transition-transform duration-300 origin-left" data-id="element-182">
              <service.icon className="h-5 md:h-6 w-5 md:w-6 text-black stroke-[1.5]" data-id="element-183" />
            </div>
            <h3 className="text-lg md:text-xl font-bold text-black mb-3 group-hover:underline decoration-1 underline-offset-4 transition-all" data-id="element-184">
              {service.title}
            </h3>
            <p className="text-neutral-500 mb-6 md:mb-8 text-sm leading-relaxed min-h-[3rem]" data-id="element-185">
              {service.description}
            </p>
            <div className="flex items-center" data-id="element-186">
              <span className="text-black font-medium text-sm border-b border-neutral-200 group-hover:border-black transition-colors pb-0.5" data-id="element-187">
                {service.price}
              </span>
            </div>
          </div>)}
      </div>

      {/* Decorative divider */}
      <div className="mt-16 md:mt-24 flex items-center gap-4" data-id="element-188">
        <div className="h-px flex-1 bg-neutral-200" data-id="element-189"></div>
        <span className="text-xs text-neutral-400 uppercase tracking-wider text-center px-2" data-id="element-190">
          Індивідуальний підхід до кожного клієнта
        </span>
        <div className="h-px flex-1 bg-neutral-200" data-id="element-191"></div>
      </div>
    </Section>;
}